module.exports = __webpack_public_path__ + "static/media/yfi_icon.e2a5f6da.png";